import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Icon from '../../../base/icons/components/Icon';
const useStyles = makeStyles()(theme => {
    return {
        prejoinPreviewDropdownBtn: {
            alignItems: 'center',
            color: '#1C2025',
            cursor: 'pointer',
            display: 'flex',
            height: 40,
            fontSize: 15,
            lineHeight: '24px',
            padding: '0 16px',
            backgroundColor: theme.palette.field02,
            '&:hover': {
                backgroundColor: theme.palette.field02Hover
            }
        },
        prejoinPreviewDropdownIcon: {
            display: 'inline-block',
            marginRight: 16,
            '& > svg': {
                fill: '#1C2025'
            }
        }
    };
});
/**
 * Buttons used for pre meeting actions.
 *
 * @returns {ReactElement}
 */
const DropdownButton = ({ dataTestId, icon, onButtonClick, onKeyPressed, label }) => {
    const { classes } = useStyles();
    return (React.createElement("div", { className: classes.prejoinPreviewDropdownBtn, "data-testid": dataTestId, onClick: onButtonClick, onKeyPress: onKeyPressed, role: 'button', tabIndex: 0 },
        React.createElement(Icon, { className: classes.prejoinPreviewDropdownIcon, color: '#1C2025', size: 24, src: icon }),
        label));
};
export default DropdownButton;
